<script lang="ts">
  import { EmptyLabelDefault } from '$provider/constants/global';
  import { getFromObject } from '$shared/helpers/utils';

  interface Props {
    row?: any;
    col?: any;
    onevent?: (payload: any) => void;
  }

  let { row = {}, col = {}, onevent }: Props = $props();

  let value = $derived(getFromObject(col.id, row));
</script>

<td class="data-table-col">
  <div
    class="col-cell"
    class:multiline={col.multiline}
    title={!col.cellComponent && col.allowTitleAttribute ? value : undefined}
    class:nowrap={!col.multiline}
  >
    {#if col.cellComponent}
      {@const CellComponent = col.cellComponent}
      <CellComponent {row} {col} {onevent} />
    {:else}
      {value || EmptyLabelDefault}
    {/if}
  </div>
</td>

<style>
  .data-table-col {
    border-bottom: 1px solid #e2e4e8;
    vertical-align: middle;
  }
  .col-cell {
    min-height: 36px;
    display: flex;
    height: 100%;
    align-items: center;
    padding: 0 8px;
    color: var(--grey-dark);
  }

  .col-cell.multiline {
    height: auto;
  }
  .col-cell.nowrap {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    display: block;
    line-height: 36px;
  }
</style>
